import React from "react"
import { StaticQuery, graphql } from "gatsby"
import SelectTermBox from "./SelectTermBox.js"
import SearchTermBar from "./SearchTermBar.js"
import {
  Row } from "reactstrap"
import * as d3 from "d3"


export class BarChart extends React.Component {
  constructor(props){
    super(props);

    const defaultTerm = "disciplinarity"

    this.state = {
      data: props.data.dataJson,
      currentTerm: defaultTerm,
      currentTermData: this.props.data.dataJson.corpusTerms.terms.filter( entry =>
        {return entry.term === defaultTerm}
      )[0]
    }
    this.drawGraph = this.drawGraph.bind(this);
    this.componentWillUpdate = this.componentWillUpdate.bind(this);
    this.handleResize = this.handleResize.bind(this);
  }

  getTermData(term){
    return this.state.data.corpusTerms.terms.filter( entry =>
      {return entry.term === term}
    )[0]
  }

  componentWillUpdate(nextProps, nextState){
    d3.selectAll("graph > *").remove();
  }

  handleResize(){
    this.componentWillUpdate();
    this.drawGraph();
  }

  componentDidMount(){
    this.drawGraph();
     window.addEventListener('resize',this.handleResize);
  }

  componentWillUnmount(){
    window.removeEventListener('resize', this.handleResize);
  }

  drawGraph(){
    var newTerm = this.state.currentTerm;

    var newTermData = this.getTermData(newTerm);

    // The following was based off of
    // https://bl.ocks.org/gordlea/27370d1eea8464b04538e6d8ced39e89
    // and
    // https://bl.ocks.org/d3noob/23e42c8f67210ac6c678db2cd07a747e


    // 2. Use the margin convention practice
    var margin = {top: 50, right: 20, bottom: 50, left: 100}
      , width = window.innerWidth - margin.left - margin.right // Use the window's width
      , height = window.innerHeight - margin.top - margin.bottom; // Use the window's height

    // 5. X scale will use the index of our data
    var xScale = d3.scaleTime()
      .domain([new Date(1995, 1, 1), new Date(2015, 1, 1)])
      .range([0, width-125]); // output

    // 6. Y scale will use the randomly generate number
    var yScale = d3.scaleLinear()
        .domain([0, (Math.max(...newTermData.distributions) + .0001 )]) // input
        .range([height, 0]); // output

    // 7. d3's line generator
    var line = d3.line()
        .x(function(d, i) { return xScale(new Date(i+1995,1,1)); }) // set the x values for the line generator
        .y(function(d) { return yScale(d.y); }) // set the y values for the line generator
        .curve(d3.curveMonotoneX) // apply smoothing to the line

    // 8. An array of objects of length N. Each object has key -> value pair, the key being "y" and the value is a random number
    var dataset;

    var rv = [];
    for (var i = 0; i < newTermData.distributions.length; ++i)
      if (newTermData.distributions[i] !== undefined) rv[i] =  {'y': newTermData.distributions[i]};
    dataset = rv.reverse();


    // 1. Add the SVG to the page and employ #2
    var svg = d3.select("graph").append("svg")
        .attr("width", "100%")
        .attr("height", height + margin.top + margin.bottom)
      .append("g")
        .attr("transform", "translate(" + margin.left + "," + margin.top + ")");

    // 3. Call the x axis in a group tag
    svg.append("g")
        .attr("class", "x axis")
        .attr("transform", "translate(0," + height + ")")
        .call(d3.axisBottom(xScale)); // Create an axis component with d3.axisBottom

    // 4. Call the y axis in a group tag
    svg.append("g")
        .attr("class", "y axis")
        .call(d3.axisLeft(yScale)); // Create an axis component with d3.axisLeft

    // 9. Append the path, bind the data, and call the line generator
    svg.append("path")
        .datum(dataset) // 10. Binds data to the line
        .attr("class", "line") // Assign a class for styling
        .attr("d", line); // 11. Calls the line generator

    var div = d3.select("main").append("div")
      .attr("class", "tooltip")
      .style("opacity", 0);

    // 12. Appends a circle for each datapoint
    svg.selectAll(".dot")
        .data(dataset)
      .enter().append("circle") // Uses the enter().append() method
        .attr("class", "dot") // Assign a class for styling
        .attr("cx", function(d, i) { return xScale(new Date(i+1995,1,1)) })
        .attr("cy", function(d) { return yScale(d.y) })
        .attr("r", 5)
        .on("mouseover", function(d) {
              div.transition()
                .duration(200)
                .style("opacity", .9);
              div.html(d.y)
                .style("left", (d3.event.pageX) + "px")
                .style("top", (d3.event.pageY - 28) + "px");
            })
        .on("mouseout", function(d) {
              div.transition()
                .duration(500)
                .style("opacity", 0);
        });

        // Add the x Axis
        svg.append("g")
            .attr("transform", "translate(0," + height + ")")
            .call(d3.axisBottom(xScale));

        // text label for the x axis
        svg.append("text")
            .attr("transform",
                  "translate(" + (width/2) + " ," +
                                 (height + (margin.top)) + ")")
            .style("text-anchor", "middle")
            .text("Year");

        // Add the y Axis
        svg.append("g")
            .call(d3.axisLeft(yScale));

        // text label for the y axis
        svg.append("text")
            .attr("transform", "rotate(-90)")
            .attr("y", 0 - (3*(margin.left/4)))
            .attr("x",0 - (height / 2))
            .attr("dy", "1em")
            .style("text-anchor", "middle")
            .text("Relative Frequencies");
  }
  // The above was based off of
  // https://bl.ocks.org/gordlea/27370d1eea8464b04538e6d8ced39e89
  // and
  // https://bl.ocks.org/d3noob/23e42c8f67210ac6c678db2cd07a747e

  componentDidUpdate(){
    this.drawGraph();
  }



  handleSelectChange(e){
    e.preventDefault();
    this.updateTerm(e.target.value);
  }

  handleSearchChange(term){
    this.updateTerm(term);
  }

  updateTerm(term){
    this.setState({
      currentTerm: term,
      currentTermData: this.getTermData(term)
    });
  }

  render(){
    return(
      <>
        <Row style={{margin:`auto`}}>
          <SelectTermBox value={this.state.currentTerm} handleChange={this.handleSelectChange.bind(this)} />
          <SearchTermBar data={this.state.data} handleChange={this.handleSearchChange.bind(this)} />
          <h3 className="col-md-5" style={{textAlign:"right"}}>Relative frequencies of the term <em>"{this.state.currentTerm}"</em> (1995-2015)
            <p><small>{this.state.currentTermData.rawFreq} occurances in 21 documents</small></p>
          </h3>
        </Row>
        <graph width="95%" height="500px"></graph>
      </>
    )
  }
}

export default props => (
  <StaticQuery
    query={graphql`
    query {
      dataJson {
        corpusTerms {
          total
          terms {
            term
            inDocumentsCount
            rawFreq
            relativeFreq
            comparisonRelativeFreqDifference
            relativePeakedness
            relativeSkewness
            distributions
          }
        }
      }
    }
  `}
    render={data => <BarChart data={data} {...props} />}
  />
)
